import { SaveToWorkspaceV2 } from 'patsnap-biz';
import { workspaceApiUrlPrefix } from 'library-@/config/constants';
import psHttp from '@patsnap/common-ps-http';
import patsnapPopupManager from '@patsnap-ui/extensions/lib/utils/popup/popup-manager';
import saveToWorkspaceI18n from '@patsnap-biz/save-to-workspace-v2/locales';
import { RavenInsertMeta } from 'library-@/services/sentry';
import { WORKSPACE_URI } from 'library-@/config/apiConfig';

const {
    SavePatentToWorkspace,
    PatentService,

    SavePaperToWorkspace,
    PaperService,

    SaveSequenceToWorkspace,
    SequenceService,

    SequenceSubjectService,
    SaveSequenceSubjectToWorksapce,
    VCService,
    MAService,
    MRService,

    DrugService,
    SaveDrugToWorkspace,

    ClinicalService,
    SaveClinicalToWorkspace,

} = SaveToWorkspaceV2;

const DEFAULT_CONFIG = {
    axiosInstance: psHttp,
    baseUrl: workspaceApiUrlPrefix,
    workspaceProductDomain: WORKSPACE_URI,
};

const setDefaultPatsnapZIndex = () => {
    // 修复biz中新版element-ui盖住patsnap-ui的Toast的z-index问题，统一element-ui版本后可以移除;
    patsnapPopupManager.zIndex = 5000;
};

const initSaveToWorkspaceI18n = ({ i18n, lang = 'en' }) => {
    if (!i18n) return;
    i18n.mergeLocaleMessage(lang, saveToWorkspaceI18n[lang]);
};

const trackSaveToWorkspace = (params = {}) => {
    console.log('TrackSaveToWorkspace:', params);
    RavenInsertMeta('Workspace', 'Save To Workspace', {
        version: 'V3',
        ...params
    });
};

export {
    SavePatentToWorkspace,
    PatentService,

    SavePaperToWorkspace,
    PaperService,

    SaveSequenceToWorkspace,
    SequenceService,

    SequenceSubjectService,
    SaveSequenceSubjectToWorksapce,

    DrugService,
    SaveDrugToWorkspace,

    ClinicalService,
    SaveClinicalToWorkspace,

    VCService,
    MAService,
    MRService,

    DEFAULT_CONFIG,
    setDefaultPatsnapZIndex,
    initSaveToWorkspaceI18n,
    trackSaveToWorkspace,
    saveToWorkspaceI18n,
};
